export const localeMap = {
  en: "English",
  es: "Español",
  ca: "Català",
  it: "Italiano",
  pt: "Português",
  fr: "Français",
  de: "Deutsch",
} as const

export const locales = Object.keys(localeMap) as (keyof typeof localeMap)[]
export const getLanguageLabel = (locale: Locale) => localeMap[locale]

export function getLocaleDisplayName(code: string | null | undefined): string {
  if (!code) return ""
  return isLocale(code) ? localeMap[code] : code
}

export type Locale = (typeof locales)[number]

export function isLocale(locale?: string): locale is Locale {
  if (!locale) {
    return false
  }
  return locales.includes(locale as Locale)
}

export const parseLocale = (locale: string | null | undefined): Locale => {
  if (!locale) {
    return fallbackLocale
  }

  if (isLocale(locale)) {
    return locale
  }

  return fallbackLocale
}

export const fallbackLocale = "en" satisfies Locale

export function getPublicationLocales(
  defaultLocale: Locale,
  additionalLanguages: Locale[] | null,
): Locale[] {
  if (!additionalLanguages) {
    return locales
  }
  const additional = additionalLanguages.filter(l => l !== defaultLocale)
  return [defaultLocale, ...additional]
}
